export const OPERATING_EXPENSE_DOCUMENT_DROP_DOWN_ITEMS = [
    {
        id: "operating-expenses",
        text: "Operating Expenses"
    },
]